import b from 'b_';
import cx from 'classnames';
import { ThreeDots as ThreeDotsIcon } from 'education-icons';
import React from 'react';

import { Button } from '../button/button';
import { BUTTON_SIZE } from '../button/types';

import { DOTS_CONTROL_ICON_DIRECTION, DOTS_CONTROL_VIEW } from './typings';

import './dots-control.scss';

interface DotsControlProps {
    direction: DOTS_CONTROL_ICON_DIRECTION;
    disabled?: boolean;
    mix?: string;
    onClick?: (e: React.MouseEvent<HTMLElement>) => void;
    onMouseDown?: (e: React.MouseEvent<HTMLElement>) => void;
    view: DOTS_CONTROL_VIEW;
    size?: BUTTON_SIZE;
}

class DotsControl extends React.PureComponent<DotsControlProps> {
    static defaultProps = {
        direction: DOTS_CONTROL_ICON_DIRECTION.HORIZONTAL,
        view: DOTS_CONTROL_VIEW.CLEAR,
    };

    static DIRECTIONS = DOTS_CONTROL_ICON_DIRECTION;
    static VIEWS = DOTS_CONTROL_VIEW;

    handleDotsClick = (e: React.MouseEvent<HTMLElement>) => {
        e.preventDefault();

        const { disabled, onClick } = this.props;

        if (!disabled && onClick) {
            onClick(e);
        }
    };

    mapViewToButtonView() {
        const { view } = this.props;
        switch (view) {
            case DOTS_CONTROL_VIEW.PSEUDO:
                return Button.VIEW.PSEUDO;
            case DOTS_CONTROL_VIEW.CLEAR:
                return Button.VIEW.CLEAR;
            default:
                return Button.VIEW.CLEAR;
        }
    }

    render() {
        const { direction, disabled, mix, onMouseDown, size } = this.props;
        const buttonView = this.mapViewToButtonView();

        return (
            <Button
                className={cx('dots-control', mix)}
                disabled={disabled}
                icon={<ThreeDotsIcon className={b('dots-control', 'dots-icon', { direction })} />}
                onClick={this.handleDotsClick}
                onMouseDown={onMouseDown}
                size={size || Button.SIZE.M}
                view={buttonView}
            />
        );
    }
}

export default DotsControl;
